export default __webpack_public_path__ + "static/media/committee.8edbc038.png";